module.exports = __webpack_public_path__ + "static/media/shape_J.4800dfac.glb";